import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import camelcaseKeys from "camelcase-keys";
import {Role} from "../../shared/models/role.model";

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  get(): Observable<any> {
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `role/getList/`)
  }

  getNames(): Observable<any> {
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `role/getListOfNames/`)
  }

  create(newRole: Role): Observable<any> {
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'role/create/',
      camelcaseKeys(newRole as any, {deep: true, pascalCase: true}))
      .pipe(map(result => result?.data));
  }

  getUserCountByRole(roleId: string): Observable<number> {
    return this.http.get<number>(this.brennerSoftwareApiEndpoint + `role/getNumberOfUsersAssignedToRole/${roleId}/`);
  }

  remove(roleId: string): Observable<string>{
    return this.http.delete<any>(this.brennerSoftwareApiEndpoint + `role/delete/${roleId}/`)
      .pipe(map(result => result?.data?.id));
  }

  update(updatedRole: Role): Observable<any>{
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'role/modify/',
      camelcaseKeys(updatedRole as any , {deep:true, pascalCase: true}))
      .pipe(map(result => result?.data));
  }


}
